import { secondsToDays } from './helpers/helpers';
import { isString } from 'lodash';

export const getSkuFromLink = (link) => {
  try {
    const [, withoutMainLink] = link.split('.ru/');
    return Number(withoutMainLink.split('-')[0]);
  } catch {
    return link;
  }
};

export const getMonthName = (time = Date.now() / 1000, locale = 'en-US', toGenitive = false, t) => {
  const monthGenitive = {
    [t('other.monthsGenitive.0.text')]: t('other.monthsGenitive.0.genitive'),
    [t('other.monthsGenitive.1.text')]: t('other.monthsGenitive.1.genitive'),
    [t('other.monthsGenitive.2.text')]: t('other.monthsGenitive.2.genitive'),
    [t('other.monthsGenitive.3.text')]: t('other.monthsGenitive.3.genitive'),
    [t('other.monthsGenitive.4.text')]: t('other.monthsGenitive.4.genitive'),
    [t('other.monthsGenitive.5.text')]: t('other.monthsGenitive.5.genitive'),
    [t('other.monthsGenitive.6.text')]: t('other.monthsGenitive.6.genitive'),
    [t('other.monthsGenitive.7.text')]: t('other.monthsGenitive.7.genitive'),
    [t('other.monthsGenitive.8.text')]: t('other.monthsGenitive.8.genitive'),
    [t('other.monthsGenitive.9.text')]: t('other.monthsGenitive.9.genitive'),
    [t('other.monthsGenitive.10.text')]: t('other.monthsGenitive.10.genitive'),
    [t('other.monthsGenitive.11.text')]: t('other.monthsGenitive.11.genitive'),
  };

  const date = new Date(time * 1000);
  const month = new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'Europe/Moscow' })
    .format(date)
    .toLowerCase();
  return toGenitive ? monthGenitive[month] ?? month : month;
};

export const getMoscowTime = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utc + 3 * 60 * 60 * 1000);
};

export const checkOnGoToShopBtn = (attr, title, t) =>
  [attr, attr?.attr].some((obj) => obj?.tag === 'a') &&
  [t('other.toShop'), t('other.afterPurchase')].some((text) => attr?.text?.includes?.(text)) &&
  title;

export const getReward = (prizeData, t) => {
  const prize = prizeData ?? {};

  if ([prize?.type === 'Ticket', prize?.type === 'Promocode' && !isString(prize?.promocode)].some(Boolean))
    return {
      value: 1,
      type: 'static',
      field: { Promocode: 'promocode', Ticket: 'ticket' }[prize?.type],
    };

  const fields = [
    'money',
    'attempts',
    'score',
    'gacha_item_count',
    'reward_bonuses',
    'gacha_event_cash',
    'promocode',
    'premium_time',
    'beauties',
  ];

  let activePrize = {};

  for (const key in prize)
    if (fields.includes(key) && Boolean(prize[key])) {
      activePrize = { [key]: prize[key] };
      break;
    }

  let [[key, value] = []] = Object.entries(activePrize);

  ({
    premium_time() {
      const { remainder } = secondsToDays(value, t);
      value = remainder;
    },
  })[key]?.();

  return { value, type: typeof value === 'number' || prizeData?.hasBuff ? 'counter' : 'static', field: key };
};

export const canGetPremiumReward = (str, price, attempts, charms, t) => {
  const premiumRewards =
    [
      { value: price, text: t('other.coins') },
      { value: attempts, text: t('other.energies') },
      { value: charms, text: t('other.charms') },
    ].filter(({ value, text }) => typeof value === 'number' && !!value) ?? {};

  if (!premiumRewards.length) return '';

  const premiumPrize = premiumRewards.reduce(
    (acc, { value, text }, i) => `${acc}${!!i ? ';   ' : ''}+${value} ${text}`,
    '',
  );

  return str.replace('{{value}}', `<b>${premiumPrize}</b>`);
};
